import {
  Button,
  ButtonSize,
  ButtonType,
  Icon,
  Icons,
  MessageBox,
  MessageBoxStatus,
} from "@yy/tofu-ui-react";
import classNames from "classnames";
import qs from "qs";
import React, { useContext, useMemo, useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { animated, useSpring, useSprings } from "react-spring";
import { useWheel } from "react-use-gesture";
import App, {
  CertStatusContext,
  LoginStatusContext,
  SettleSwitchContext,
  UserInfoContext,
  UserRoleContext,
} from "../App";
import icon1 from "../images/icon-1.png";
import icon2 from "../images/icon-2.png";
import icon3 from "../images/icon-3.png";
import icon4 from "../images/icon-4.png";
import icon5 from "../images/icon-5.png";
import icon6 from "../images/icon-6.png";
import icon7 from "../images/icon-7.png";
import img1 from "../images/img-1.png";
import img2 from "../images/img-2.png";
import img3 from "../images/img-3.png";
import img4 from "../images/img-4.png";
import textImg from "../images/text.png";
import { stat } from "../lib/hooks/useHiidoPV";
import { isAnchor, isGuild, UserRole, HttpServiceMsg } from "../lib/util";
import Carousel from "./Carousel";
import { ChannelIdContext } from "./ChannelIdContextWrap";
import FloatTips from "./FloatTips";
import { ModalRoutes } from "./ModalSwitch/ModalSwitch";
import fetchers from "../models/fetchers";
import fetcher, { paths } from "../lib/fetcher";
import { RegGuildResult } from "../models/RegGuildResult";

const BlackMsg: Map<number, string> = new Map([
  [106, "本账号曾经因公会健康分小于零分被永久撤销公会身份，故无法再次申请成为公会，如有疑问请咨询10频道客服"],
  [107, "本个人实名信息曾经因公会健康分小于零分被永久撤销公会身份，故无法再次申请成为公会，如有疑问请咨询10频道客服"],
  [108, "本账号曾经因公会健康分小于零分被永久撤销公会身份，故无法再次申请成为公会，如有疑问请咨询10频道客服"],
  [109, "本企业实名信息曾经因公会健康分小于零分被永久撤销公会身份，故无法再次申请成为公会，如有疑问请咨询10频道客服"],
])

const Boards = () => {
  const history = useHistory();
  const userRole = useContext(UserRoleContext);
  const isLoggedIn = useContext(LoginStatusContext);
  const { isCert } = useContext(CertStatusContext);
  const a = useContext(ChannelIdContext);
  const [nextSpring, setNextSpring] = useSpring(() => ({
    opacity: 1,
    display: "flex",
  }));
  const boardItemKeys = [0, 1, 2];
  const [springs, setSprings] = useSprings(boardItemKeys.length, (i) => ({
    height: 421,
  }));
  const [scrollTop, setScrollTop] = useSpring(() => ({ scroll: 0 }));
  const [expand, setExpand] = useState(false);
  const [signed, setSigned] = useState(false);  // 是否签署了公会服务协议，默认否
  const bind = useWheel(({ movement: [_, my] }) => {
    if (my > 0) {
      setNextSpring({ opacity: 0, display: "none" });
      setScrollTop({ scroll: 481 });
      setExpand(true);
      setSprings((i: any) => {
        if (i === 0) {
          return { height: 765 };
        } else if (i === 1) {
          return { height: 804 };
        } else {
          return { height: 822 };
        }
      });
    }
  });
  const userInfo = useContext(UserInfoContext);
  const isBaiduUser = userInfo && userInfo.isBaidu === "1";
  const isSettleSwitchOn = useContext(SettleSwitchContext);
  const shouldLimitBaiduUserAccess = isBaiduUser && isSettleSwitchOn;


  // 获得公会协议签署状态
  const getAgreementSignStatus = async () => {
    const rs = await fetchers['GET/protocol/check']({ includeText: false })
    if (rs.code === 0) {
      const { data } = rs
      if (data?.hasSign) {
        setSigned(true)
      }
    }
  }
  // TODO
  // useEffect(() => {
  //   history.replace({
  //     pathname: ModalRoutes.GuildServiceAgreement,
  //     search: qs.stringify({ beGuildRoute: ModalRoutes.BeStarGuildProcess }, { addQueryPrefix: true }),
  //   });
  // }, [history])
  // TODO

  const showSDKConfirmDialog = () => {
    return new Promise((resolve) => {
      MessageBox({
        title: "提示",
        width: "420px",
        status: MessageBoxStatus.WARN,
        desc: "成为公会后，将无法在YY百战直播平台再次申请成为公会",
        okTxt: '下一步',
        cancelTxt: "取消",
        onOk: () => {
          resolve(true)
          return true
        },
        onCancel: () => {
          resolve(false)
        }
      })
    })
  }

  async function onClickNormal() {
    // 数据上报
    stat.emit({
      eventid: 20030927,
      act_type: "201",
      more_info: { aisle_src_id: a },
    });

    // 未登录
    if (!isLoggedIn) {
      const { user } = await App.onHeaderReady();
      user.showYYLoginBox();
    } else {
      // 已经登录但是没实名认证
      if (!isCert) {
        history.push(ModalRoutes.CertHint);
        return;
      }

      const blackRes = (await fetcher.post(`${paths.roleBlacklist}?role=2`)) as RegGuildResult;
      if (blackRes?.code !== 0 && [1, 106, 107, 108, 109].includes(blackRes?.code)) {
        // NOTE: 此接口后端没有返回 msg
        MessageBox({
          title: "提示",
          status: MessageBoxStatus.WARN,
          desc: BlackMsg.get(blackRes.code) || HttpServiceMsg.ServiceError,
          showOk: false,
          cancelTxt: "确定",
        });
        return;
      }

      // SDK 二次确认
      const confirmResult = await showSDKConfirmDialog();
      if (!confirmResult) return;

      // 普通用户
      if (userRole === UserRole.NormalUser) {
        if (signed) {
          // 进入填写公会资料页
          history.push(ModalRoutes.GuildInfoForm);
        } else {
          // 未签署公会协议，打开签署协议弹窗。
          history.replace({
            pathname: ModalRoutes.GuildServiceAgreement,
            search: qs.stringify({ beGuildRoute: ModalRoutes.GuildInfoForm, scene: 1 }, { addQueryPrefix: true }),
          });
        }
        return;
      }

      // 主播
      if (isAnchor(userRole)) {
        MessageBox({
          title: "提示",
          width: "420px",
          status: MessageBoxStatus.FAIL,
          desc: "您当前是主播身份， 不能成为公会",
          showOk: false,
          cancelTxt: "知道了",
        });
        return;
      }
    }
  }

  async function onClickStar() {
    // 数据上报
    stat.emit({
      eventid: 20030927,
      act_type: "206",
      more_info: { aisle_src_id: a },
    });

    // 未登录
    if (!isLoggedIn) {
      const { user } = await App.onHeaderReady();
      await user.showYYLoginBox();
    } else {
      // 已经登录但是没实名认证
      if (!isCert) {
        history.push(ModalRoutes.CertHint);
        return;
      }

      const blackRes = (await fetcher.post(`${paths.roleBlacklist}?role=2`)) as RegGuildResult;
      if (blackRes?.code !== 0 && [1, 106, 107, 108, 109].includes(blackRes?.code)) {
        // NOTE: 此接口后端没有返回 msg
        MessageBox({
          title: "提示",
          status: MessageBoxStatus.WARN,
          desc: BlackMsg.get(blackRes.code) || HttpServiceMsg.ServiceError,
          showOk: false,
          cancelTxt: "确定",
        });
        return;
      }

      // SDK 二次确认
      const confirmResult = await showSDKConfirmDialog();
      if (!confirmResult) return;

      // 普通用户和普通公会
      if ([UserRole.NormalUser, UserRole.NormalGuild].includes(userRole)) {
        if (signed) {
          // 已签署公会服务协议，直接进入星级公会流程
          history.push(ModalRoutes.BeStarGuildProcess)
        } else {
          // 未签署公会协议，打开签署协议弹窗。
          history.replace({
            pathname: ModalRoutes.GuildServiceAgreement,
            search: qs.stringify({ beGuildRoute: ModalRoutes.BeStarGuildProcess, scene: 2 }, { addQueryPrefix: true }),
          });
        }
        return;
      }

      // 主播
      if (isAnchor(userRole)) {
        MessageBox({
          title: "提示",
          width: "420px",
          status: MessageBoxStatus.FAIL,
          desc: "您当前是主播身份， 不能成为公会",
          showOk: false,
          cancelTxt: "知道了",
        });
        return;
      }
    }
  }

  function onClickGold() {
    // 数据上报
    stat.emit({
      eventid: 20030927,
      act_type: "210",
      more_info: { aisle_src_id: a },
    });

    window.open("//www.yy.com/gi/management/grade-upgrade/guildUpgrade", "_blank");
  }

  const disableNormal = isGuild(userRole);
  const disableStar = useMemo(() => {
    if (shouldLimitBaiduUserAccess) return true; // 百度公会暂不支持升级星级
    return [UserRole.GoldGuild, UserRole.StarGuild].includes(userRole);
  }, [shouldLimitBaiduUserAccess, userRole]);

  const disableGold = userRole !== UserRole.StarGuild;
  const buttonStyle = {
    width: 264,
    height: 62,
    borderRadius: 62,
    fontWeight: 500,
    fontSize: "22px",
    margin: "0 auto",
  };

  useEffect(() => {
    getAgreementSignStatus()
  }, [])

  return (
    <animated.div className="App" scrollTop={scrollTop.scroll} {...bind()}>
      <Carousel />

      <div className="wrap">
        <img className="big-text" src={textImg} alt="成为YY星级公会，立享7大权益" />
        <p className="sub-big-text">更多流量、更高分成</p>

        <div className={classNames("boards", expand && "bottom-corner")}>
          {springs.map((spring, i) => {
            if (i === 0) {
              return (
                <div className="board-wrap board-1" key={i}>
                  <div className="badge badge-1" />
                  <animated.div className="board" style={spring}>
                    <h1>普通公会</h1>
                    <Button
                      onClick={onClickNormal}
                      disabled={disableNormal}
                      size={ButtonSize.XL}
                      style={buttonStyle}
                    >
                      成为普通公会
                    </Button>
                    <div className="gap">
                      <div className="gap-title">公会权益</div>
                    </div>
                    <section className="section">
                      <ul>
                        <li>固定比例为10%的分成</li>
                        <li>绑定并管理主播</li>
                      </ul>
                    </section>
                    <div className="gap">
                      <div className="gap-title">申请条件</div>
                    </div>
                    <ul className="award">
                      <li>
                        <img src={img1} alt="非主播身份且已实名认证" />
                        <p>
                          非主播身份 <br />
                          且已实名认证
                        </p>
                      </li>
                    </ul>
                  </animated.div>
                </div>
              );
            } else if (i === 1) {
              return (
                <div className="board-wrap board-2 board-lg" key={i}>
                  <animated.div
                    style={nextSpring}
                    className="scroll-next"
                    onClick={() => {
                      setNextSpring({ opacity: 0, display: "none" });
                      setScrollTop({ scroll: 481 });
                      setExpand(true);
                      setSprings((i: any) => {
                        if (i === 0) {
                          return { height: 765 };
                        } else if (i === 1) {
                          return { height: 804 };
                        } else {
                          return { height: 822 };
                        }
                      });
                    }}
                  >
                    <Icon type={Icons.Arrow} rotate={270} />
                  </animated.div>

                  <div className="badge badge-2" />
                  <animated.div className="board" style={spring}>
                    <h1>星级公会</h1>
                    <div className="tag-1">95%公会选择</div>
                    <Button
                      onClick={onClickStar}
                      type={ButtonType.Emphasis}
                      style={buttonStyle}
                      disabled={disableStar}
                    >
                      成为星级公会
                    </Button>
                    <div className="gap">
                      <div className="gap-title">7大权益</div>
                    </div>
                    <section className="section section-2">
                      <div className="col col-1">
                        <div className="row">
                          <div className="row-icon">
                            <img src={icon1} alt="" />
                          </div>
                          <p>最高30%的收益分成</p>
                          <div className="privilege-tag">特权</div>
                        </div>
                        <div className="row">
                          <div className="row-icon">
                            <img src={icon2} alt="" />
                          </div>
                          <p>第一时间获得新主播专属绑定推荐池</p>
                        </div>
                        <div className="row">
                          <div className="row-icon">
                            <img src={icon3} alt="" />
                          </div>
                          <p>有机会获得获得官方活动优先参与资格</p>
                        </div>
                        <div className="row">
                          <div className="row-icon">
                            <img src={icon4} alt="" />
                          </div>
                          <p>旗下绑定主播均可获得星级主播荣耀身份</p>
                        </div>
                      </div>
                      <div className="col">
                        <div className="row">
                          <div className="row-icon">
                            <img src={icon5} alt="" />
                          </div>
                          <p>星级体系专属资源包</p>
                          <div className="privilege-tag">特权</div>
                        </div>
                        <div className="row">
                          <div className="row-icon">
                            <img src={icon6} alt="" />
                          </div>
                          <p>有机会获得重点公会扶持资源</p>
                        </div>
                        <div className="row">
                          <div className="row-icon">
                            <img src={icon7} alt="" />
                          </div>
                          <p>新主播评级专属推举资格</p>
                        </div>
                      </div>
                    </section>
                    <div className="gap">
                      <div className="gap-title">
                        <span>申请条件</span>
                      </div>
                      <a
                        href="//www.yy.com/n/38_784.html"
                        className="tf-ui-link know-more"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        了解更多 <Icon type={Icons.Arrow} />
                      </a>
                    </div>

                    <ul className="award award-2">
                      <li>
                        <img src={img1} alt="非主播身份且已实名认证" />
                        <p>
                          非主播身份 <br />
                          且已实名认证
                        </p>
                      </li>
                      <li>
                        <img src={img2} alt="缴纳3,000元保证金 可退还" />
                        <p>
                          缴纳3,000元 <br />
                          保证金, 可退还
                        </p>
                      </li>
                      <li>
                        <img src={img3} alt="近3个月公会旗下 主播蓝钻收入达标" />
                        <p>
                          近3个月公会旗下 <br />
                          主播蓝钻收入达标
                        </p>
                      </li>
                    </ul>

                    <a
                      href="//www.yy.com/web/guild_introduce/index.html"
                      className="be-guild-link"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      为什么选择入驻YY公会？
                    </a>
                  </animated.div>
                </div>
              );
            } else if (i === 2) {
              return (
                <div className="board-wrap board-3" key={i}>
                  <div className="badge badge-3" />
                  <animated.div className="board" style={spring}>
                    <h1>金牌公会</h1>
                    <Button style={buttonStyle} onClick={onClickGold} disabled={disableGold}>
                      升级为金牌公会
                    </Button>
                    <div className="gap">
                      <div className="gap-title">公会权益</div>
                    </div>
                    <section className="section">
                      <ul>
                        <li>拥有星级公会所有权益</li>
                        <li>对公分成权益</li>
                        <li>绑定金牌艺人</li>
                      </ul>
                    </section>
                    <div className="gap">
                      <div className="gap-title">申请条件</div>
                      <a
                        href="//www.yy.com/n/38_782.html"
                        className="tf-ui-link know-more"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        了解更多 <Icon type={Icons.Arrow} />
                      </a>
                    </div>
                    <ul className="award">
                      <li>
                        <img src={img4} alt="已成为星级公会" />
                        <p>已成为星级公会</p>
                      </li>
                      <li>
                        <img src={img3} alt="近3个月公会旗下 主播蓝钻收入达标" />
                        <p>
                          近3个月公会旗下 <br />
                          主播蓝钻收入达标
                        </p>
                      </li>
                    </ul>
                  </animated.div>
                </div>
              );
            } else {
              return null;
            }
          })}
        </div>
      </div>

      <FloatTips />
    </animated.div>
  );
};

export default Boards;
